module.exports = __webpack_public_path__ + "img/mht_x.14c27e67.jpg";